import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getQuestionCatalog, listGatheringKinds } from "@/api/event-about";

/**
 * The questions a host of one kind of gathering is asked, as the server
 * serves them, each answer with the fact or field that keeps it.
 */
export function QuestionCatalogPanel() {
  const [kind, setKind] = useState("garba");
  const kinds = useQuery({ queryKey: ["gathering-kinds"], queryFn: listGatheringKinds });
  const catalog = useQuery({ queryKey: ["question-catalog", kind], queryFn: () => getQuestionCatalog(kind) });

  return (
    <div className="card p-5 space-y-3">
      <h2 className="font-semibold">Questions by kind</h2>
      <select className="input w-64" value={kind} onChange={(e) => setKind(e.target.value)}>
        {(kinds.data?.data.kinds ?? []).map((k) => (
          <option key={k.code} value={k.code}>
            {k.label}
          </option>
        ))}
      </select>
      {catalog.error && <p className="text-xs text-red-600">{(catalog.error as Error).message}</p>}
      <ol className="text-sm text-gray-700 space-y-2">
        {(catalog.data?.data.questions ?? []).map((q) => (
          <li key={q.code}>
            <span className="font-medium">{q.heading}</span>
            <span className="text-xs text-gray-500">
              {" "}
              · {q.sheet} · {q.position}
              {q.single ? " · one" : " · several"}
              {q.inPersonOnly ? " · in person" : ""}
              {q.followUpOf ? ` · after ${q.followUpOf}` : ""}
            </span>
            <ul className="text-xs text-gray-600 pl-4">
              {q.answers.map((a) => (
                <li key={a.code}>
                  {a.label} →{a.sets.facets ? ` ${a.sets.facets.join(", ")}` : ""}
                  {a.sets.field ? ` ${a.sets.field.name} = "${a.sets.field.value}"` : ""}
                </li>
              ))}
              {q.ownWords && <li className="italic">{q.ownWords}</li>}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  );
}
